import { render } from "./Archivejob.vue?vue&type=template&id=7c9c090e&scoped=true"
import script from "./Archivejob.vue?vue&type=script&lang=js"
export * from "./Archivejob.vue?vue&type=script&lang=js"

import "./Archivejob.vue?vue&type=style&index=0&id=7c9c090e&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9c090e"]])

export default __exports__